// extracted by mini-css-extract-plugin
export default {"quiz_header":"Tx","quiz_header_wrapper":"Ux","header_button":"Vx","hidden":"Wx","gainful_logo":"Xx","MyClassEnterDone":"Yx","x_button":"Zx","logoWrapper":"ay","logoWrapperMob":"by"};
    if(module.hot) {
      // 1713969932243
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  